import { useContext, useState } from 'react';
import { FormContext } from '~/components/forms/FormContext';
import AddToWaitlistModal, {
    useIsWaitlistEnabled,
} from '~/components/waitlist/AddToWaitlistModal';
import { FormPart, FormStateName, part, state } from '~/lib/FormCssApi';

const ClassBookButton = ({
    onSelect,
    onRemove,
    isSelected,
    instance,
    settings,
}) => {
    const [showWaitlist, setShowWaitlist] = useState(false);

    const isWaitlistEnabled = useIsWaitlistEnabled(settings);

    return (
        <>
            {instance.spots_left > 0 && (
                <>
                    {isSelected && (
                        <button
                            type="button"
                            {...part(FormPart.CLASS_BOOK)}
                            {...state(FormStateName.SELECTED)}
                            className="form-button-light"
                            onClick={onRemove}
                        >
                            Selected
                        </button>
                    )}
                    {!isSelected && (
                        <button
                            type="button"
                            {...part(FormPart.CLASS_BOOK)}
                            className="form-button"
                            onClick={onSelect}
                        >
                            {settings?.bookLabel || 'Book'}
                        </button>
                    )}
                </>
            )}
            {instance.spots_left <= 0 && isWaitlistEnabled && (
                <>
                    <button
                        type="button"
                        {...part(FormPart.CLASS_BOOK)}
                        {...state(FormStateName.FULL)}
                        className="form-button"
                        onClick={() => setShowWaitlist(true)}
                    >
                        Join Waitlist
                    </button>
                    <AddToWaitlistModal
                        isOpen={showWaitlist}
                        onClose={() => setShowWaitlist(false)}
                        eventType={instance.event_type_id}
                        bookableResource={instance.bookable_resource_id}
                        start={instance.start}
                        settings={settings}
                    />
                </>
            )}
        </>
    );
};

export default ClassBookButton;
